// import Chart from "@/../node_modules/chart.js/src/chart";
import Chart from 'chart.js';

const BACKGROUND_COLORS = [
  '#000000',
  '#4a4a4a',
  '#9b9b9b',
  '#b9b9b9',
  '#f2f2f2'
];

const BORDER_COLOR = '#FFFFFF';

let circleChart;

export default {
  inserted(el, binding, vnode) {
    circleChart = new Chart(el, {
      type: 'doughnut',
      options: {
        cutoutPercentage: 83,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            usePointStyle: true,
            padding: 16
          }
        },
        elements: {
          arc: {
            backgroundColor: BACKGROUND_COLORS[0],
            borderColor: BORDER_COLOR,
            borderWidth: 4
          }
        },
        layout: {
          padding: 0
        },
        tooltips: {
          enabled: false,
          callbacks: {
            title: function(item, data) {
              return data.labels[item[0].index];
            },
            label: function(item, data) {
              const value = data.datasets[0].data[item.index];
              const sum = _.sum(data.datasets[0].data);

              return `${Math.round((value / sum) * 100)}%`;
            }
          }
        }
      },
      data: {
        labels: ['데이터 없음'],
        datasets: [
          {
            data: [100],
            backgroundColor: BACKGROUND_COLORS[4],
            hoverBorderColor: BORDER_COLOR
          }
        ]
      }
    });
  },
  update(el, binding, vnode) {
    const { value } = binding;

    if (value.data === binding.oldValue.data) {
      return;
    }

    if (_.sum(value.data) === 0) {
      circleChart.data.labels = ['데이터 없음'];
      circleChart.data.datasets[0].data = [100];
      circleChart.data.datasets[0].backgroundColor = BACKGROUND_COLORS[4];
      circleChart.options.legend.display = false;
      circleChart.options.tooltips.enabled = false;
    } else {
      circleChart.data.labels = value.labels;
      circleChart.data.datasets[0].data = value.data;
      circleChart.data.datasets[0].backgroundColor =
        value.backgroundColor || BACKGROUND_COLORS;
      circleChart.options.legend.display = value.options.isLegendVisible;
      circleChart.options.tooltips.enabled = true;
    }

    circleChart.update();
  }
};
